import { render, staticRenderFns } from "./shoppingIndex.vue?vue&type=template&id=f80a433a&scoped=true"
import script from "./shoppingIndex.vue?vue&type=script&lang=js"
export * from "./shoppingIndex.vue?vue&type=script&lang=js"
import style0 from "./shoppingIndex.vue?vue&type=style&index=0&id=f80a433a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80a433a",
  null
  
)

export default component.exports